import { render, staticRenderFns } from "./AiBuilderItemCard.vue?vue&type=template&id=2e724eca&scoped=true"
import script from "./AiBuilderItemCard.vue?vue&type=script&lang=js"
export * from "./AiBuilderItemCard.vue?vue&type=script&lang=js"
import style0 from "./ai-builder.css?vue&type=style&index=0&id=2e724eca&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e724eca",
  null
  
)

export default component.exports